<template>
  <div class="invoice-create-page main-content">
    <div class="page-header">
      <h3 class="page-title">{{ $tc('settings.setting',1) }}</h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><router-link slot="item-title" to="/supplier/dashboard">{{ $t('general.home') }}</router-link></li>
        <li class="breadcrumb-item"><router-link slot="item-title" to="/supplier/settings/user-profile">{{ $tc('settings.setting', 2) }}</router-link></li>
      </ol>
    </div>
    <div class="row settings-container">
      <div class="col-lg-3 settings-sidebar-container">
        <ol class="settings-sidebar">
          <li v-for="(menuItem, index) in menuItems" :key="index" class="settings-menu-item">
            <router-link :class="['link-color', {'active-setting': hasActiveUrl(menuItem.link)}]" :to="menuItem.link">
              <font-awesome-icon :icon="[menuItem.iconType, menuItem.icon]" class="setting-icon"/>
              <span class="menu-title ml-3">{{ $t(menuItem.title) }}</span>
            </router-link>
          </li>
        </ol>
      </div>
      <div class="col-lg-9">
        <transition
          name="fade"
          mode="out-in">
          <router-view/>
        </transition>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      menuItems:[]
    }
  },
  watch: {
    '$route.path' (newValue) {
      if (newValue === '/supplier/settings') {
        this.$router.push('/supplier/settings/user-profile')
      }
    }
  },
  created () {
    if (this.$route.path === '/supplier/settings') {
      this.$router.push('/supplier/settings/user-profile')
    }
    if(localStorage.getItem('role')=='user'){
      this.menuItems= [
        {
          link: '/supplier/settings/user-profile',
          title: 'settings.menu_title.account_settings',
          icon: 'user',
          iconType: 'far'
        },
      ]
    }else{
      this.menuItems= [
        {
          link: '/supplier/settings/user-profile',
          title: 'settings.menu_title.account_settings',
          icon: 'user',
          iconType: 'far'
        },
        {
          link: '/supplier/settings/company-info',
          title: 'settings.menu_title.company_information',
          icon: 'building',
          iconType: 'far'
        },
        {
          link: '/supplier/settings/addresses',
          title: 'settings.menu_title.addresses',
          icon: 'address-card',
          iconType: 'far'
        },
        {
          link: '/supplier/settings/contacts',
          title: 'settings.menu_title.contacts',
          icon: 'address-book',
          iconType: 'far'
        },
        {
          link: '/supplier/settings/customization',
          title: 'settings.menu_title.customization',
          icon: 'edit',
          iconType: 'fa'
        },
        {
          link: '/supplier/settings/preferences',
          title: 'settings.menu_title.preferences',
          icon: 'cog',
          iconType: 'fas'
        },
        {
          link: '/supplier/settings/tax-types',
          title: 'settings.menu_title.tax_types',
          icon: 'check-circle',
          iconType: 'far'
        },
        // {
        //   link: '/supplier/settings/expense-category',
        //   title: 'settings.menu_title.expense_category',
        //   icon: 'list-alt',
        //   iconType: 'far'
        // },
        // {
        //   link: '/supplier/settings/mail-configuration',
        //   title: 'settings.mail.mail_config',
        //   icon: 'envelope',
        //   iconType: 'fa'
        // },
        // {
        //   link: '/supplier/settings/notifications',
        //   title: 'settings.menu_title.notifications',
        //   icon: 'bell',
        //   iconType: 'far'
        // },
        // {
        //   link: '/supplier/settings/update-app',
        //   title: 'settings.menu_title.update_app',
        //   icon: 'sync-alt',
        //   iconType: 'fas'
        // }
      ]
    }
  },
  methods: {
    hasActiveUrl (url) {
      return this.$route.path.indexOf(url) > -1
    }
  }
}
</script>
